import styles from './Inquiry.module.css';

export function AdvisorySidePanel() {
  return (
    <div className={styles.sidePanel}>
      <div className={styles.pCard}>
        <span className={`${styles.pEye} ${styles.pEyeTeal}`}>진행 프로세스</span>
        <div className={styles.stepList}>
          {[
            '신청서 제출',
            '담당 변호사 배정 및 첫 상담 (1영업일 이내)',
            '계약 조건 안내 및 계약 체결',
            '즉시 서비스 이용 시작',
          ].map((t, i) => (
            <div key={i} className={styles.stepRow}>
              <span className={styles.stepN}>{i + 1}</span>
              <span className={styles.stepT}>{t}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function GroupSidePanel() {
  return (
    <div className={styles.sidePanel}>
      <div className={styles.pCard}>
        <span className={styles.pEye}>단체계약 대상</span>
        <div className={styles.gList}>
          {[
            <>
              시·도·구 <strong>의사회 · 치과의사회 · 한의사회</strong>
            </>,
            <>
              <strong>전문 학회 · 연구회</strong> (각 진료과 학회)
            </>,
            <>
              <strong>네트워크 의원</strong> 본사 (가맹점 일괄 계약)
            </>,
            <>
              <strong>의료협동조합</strong> 및 기타 의료인 단체
            </>,
          ].map((item, i) => (
            <div key={i} className={styles.gItem}>
              {item}
            </div>
          ))}
        </div>
      </div>
      <div className={styles.pCard}>
        <span className={styles.pEye}>단체계약 특전</span>
        <div className={styles.bList}>
          회원 개별 가입 대비 <strong>우대 요금 적용</strong>
          <br />
          단체 전용 <strong>우선 응대 채널</strong> 개설
          <br />
          연간 <strong>법률 세미나·교육</strong> 정기 제공
          <br />
          계약 규모에 따른 <strong>맞춤 조건</strong> 협의 가능
          <br />
          법무법인 오킴스 명의 <strong>MOU 체결</strong> 가능
        </div>
      </div>
    </div>
  );
}
